import axios from 'axios';

import JWTService from '@/services/JWTService';
import APIService from '@/services/APIService';

const BASE_URL = process.env.VUE_APP_BASE_URL_V1;

export default {
  /**
   * Авторизация по логину и паролю
   * @param username
   * @param password
   * @param isLocal
   * @returns {*}
   */
  auth(username, password, isLocal) {
    let url = '/oauth/signin-dispatcher';
    if (isLocal) url = '/oauth/public-signin';
    return axios.post(`${BASE_URL}${url}`, { username, password });
  },

  /**
   * Авторизация по внешнему коду
   * @param key
   * @returns {Promise<AxiosResponse<T>>}
   */
  authByCode(key) {
    const url = '/auth/signin-key';
    return axios.get(`${BASE_URL}${url}`, { params: { key } });
  },

  /**
   * Получение информации о пользователе
   * @param token
   * @returns {*}
   */
  getUserInfo() {
    const config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${JWTService.getToken()}`,
      },
    };
    return axios.get(`${BASE_URL}/user`, config);
  },

  /**
   * Логаут пользователя
   * @returns {*}
   */
  logout() {
    const token = JWTService.getToken();
    const config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    return axios.post(`${BASE_URL}/oauth/signout`, {}, config);
  },

  getTelegramAuth() {
    return APIService.get('/telegram-user/uri');
  },
  telegramAuth(payloads) {
    return APIService.post('/telegram-user/auth', payloads);
  },
  getVkAuth() {
    return APIService.get('/vk/oauth/uri');
  },
  vkAuth(payloads) {
    return APIService.post('/vk/oauth/auth', payloads);
  },

  registerStudent(payloads) {
    return APIService.post('/register/listener', payloads);
  },
  registerTeacher(payloads) {
    return APIService.post('/register/teacher', payloads);
  },
  sendVerify(payloads) {
    return APIService.post('/oauth/email', payloads);
  },
  confirmVerify(payloads) {
    return APIService.put('/oauth/email', payloads);
  },
  sendResetPas(payloads) {
    return APIService.post('/oauth/reset', payloads);
  },
  changePassword(payloads) {
    return APIService.post('/oauth/change-password', payloads);
  },
  resetPassword(payloads) {
    return APIService.put('/oauth/reset', payloads);
  },
  sendInn(inn) {
    return APIService.get(`/organizations/inn-info/${inn}`);
  },
  registerOrganization(payloads) {
    return APIService.post('/register/organization', payloads);
  },

  transformToTeacher() {
    return APIService.post('listeners/transform-to-teacher');
  },
  // registerOrganization(payloads) {
  //   return APIService({
  //     method: 'POST',
  //     url: '/register/organization',
  //     data: payloads,
  //     headers: { 'Content-Type': 'multipart/form-data' },
  //   });
  // },
};
